import React from 'react'
import { IAssociation } from '@/interfaces/search.interface'
import useMatchWindowQuery from '@wiggot/web-components/hooks/ds/useMatchWindowQuery'
import Avatar from '@dd3tech/wiggui/Avatar'
import Checkbox from '@dd3tech/wiggui/Checkbox'
import GoogleIcon from '@dd3tech/wiggui/GoogleIcon'

interface IProps {
  associations: IAssociation[]
  selectedAssociations: string[]
  onChangeAssociations: (value: any) => void
}
export const Associations = ({
  associations,
  onChangeAssociations,
  selectedAssociations
}: IProps) => {
  const { isMD } = useMatchWindowQuery()
  const maxLabelSize = isMD ? 35 : 20
  const onCheckboxChange = (value: boolean, name?: string) => {
    if (value) {
      onChangeAssociations([...selectedAssociations, name])
      return
    }
    onChangeAssociations(
      selectedAssociations.filter((association) => association !== name)
    )
  }
  return (
    <div className="flex flex-wrap gap-3">
      {associations.map(({ value, label }) => {
        const isChecked = selectedAssociations.includes(value)
        return (
          <Checkbox
            key={label}
            name={value}
            id={value}
            type="checkbox"
            as="button"
            gap="gap-3"
            items="start"
            justify="between"
            containerClassName={`flex-row-reverse items-center min-h-[92px] max-h-[92px] md:h-auto w-[calc(50%-12px)] rounded-xl p-4 outline-none [&>svg]:hidden ${
              isChecked
                ? '!border-2 border-primary !bg-primary-01'
                : 'border border-surface-strokes bg-white'
            }`}
            isChecked={isChecked}
            onChange={onCheckboxChange}
            labelClassName="max-w-[calc(100%-38px)] w-fit"
            label={
              <div className="flex items-center gap-1 max-w-[calc(100%-28px)]">
                <Avatar avatarIconType="profile" fullName={label} size="xs" />
                {label && (
                  <p
                    className={`text-[15px] text-start max-w-[calc(100%-28px)] ${
                      isChecked ? 'text-primary font-bold' : 'text-primary'
                    }`}
                  >
                    {label.length > maxLabelSize
                      ? `${label.slice(0, maxLabelSize)}...`
                      : label}
                  </p>
                )}
                {isChecked && (
                  <GoogleIcon
                    className="absolute right-4 top-[calc(50%-14px)] font-extrabold text-lg text-white"
                    name="check"
                  />
                )}
              </div>
            }
            inputClassName="!min-w-[20px] !min-h-[20px] !max-h-[20px] !w-5 h-5 !p-2 !rounded-full checked:!bg-primary checked:!border-primary"
          />
        )
      })}
    </div>
  )
}
